// dependencies
import PropTypes from "prop-types";
import React from "react";

// style
import css from "../Table.module.scss";

const Cell = (props) => {
	const { children = null, className = "", testId = "" } = props;
	return (
		<div data-testid={testId} className={`${css.Cell} ${className}`}>
			{children}
		</div>
	);
};

Cell.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	testId: PropTypes.string,
};

export default Cell;
